export enum EStatus {
  INFORMATIONAL = 'INFORMATIONAL',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export enum ENotificationType {
  PRODUCTS_LIST = 'PRODUCTS_LIST',
  SIMPLE_WITH_RELOAD = 'SIMPLE_WITH_RELOAD',
  WITH_HTML = 'WITH_HTML',
}
